import React from 'react';
import PropTypes from 'prop-types';
import { Rectangle, Typography, Cushion, FlexContainer, Button, Space } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const BuyButton = ({ outOfStock }) => {
  if (outOfStock) {
    return null;
  }

  return (
    <Button theme="primaryContrast" compact style={{ width: '90px' }}>
      <Trans i18nKey="common:buy">Buy</Trans>
    </Button>
  );
};

BuyButton.propTypes = {
  outOfStock: PropTypes.bool.isRequired,
};

const ProductCardAssignmentBadge = ({ assignment, outOfStock }) => {
  if (!assignment) {
    return null;
  }

  return (
    <Rectangle fill="primary">
      <Cushion all="small">
        <FlexContainer flexDirection="row" alignItems="center">
          <Cushion horizontal="small" component="div" style={{ flex: 1, width: '100%' }}>
            <Space bottom="xxsmall">
              <Typography color="primaryContrast" preset="tag--large" component="div">
                {assignment.requester}
              </Typography>
            </Space>
            <Typography color="primaryContrast" preset="tag--small" component="div">
              <Trans i18nKey="shop:asked_you_to_buy_this">Asked you to buy this</Trans>
            </Typography>
          </Cushion>

          <BuyButton outOfStock={outOfStock} />
        </FlexContainer>
      </Cushion>
    </Rectangle>
  );
};

ProductCardAssignmentBadge.propTypes = {
  assignment: PropTypes.shape(),
  outOfStock: PropTypes.bool,
};

ProductCardAssignmentBadge.defaultProps = {
  assignment: null,
  outOfStock: false,
};

export default ProductCardAssignmentBadge;
